import { retrieveErrorFromApi } from '../../../helper'
import { setAppErrors } from '../../action/system'
import getClientMonitorConfig from '../../axios/clientMonitorConfig/get'
import updateClientMonitorConfig from '../../axios/clientMonitorConfig/put'
import { setClientMonitorConfig, setClientMonitorConfigForbidden } from '../../action/clientMonitorConfig'
import { closeClientMonitorWindow, openClientMonitorWindow, sendMessageToClientMonitor } from '../../../component/ClientMonitorWindow/helper'
import getClientMonitorPublicConfig from '../../axios/clientMonitorConfig/public/get'
import { isNativeAppMode, withJsClientMonitor } from '../../../helper/clientMonitor'
import toggleClientMonitor from '../../axios/clientMonitorConfig/toggle'
import { storeClientMonitorQrCodePaymentSessionThunk } from '../clientMonitorCart'
import { selectIsAuthorized } from '../../selector/system'
import { selectClientMonitorItems, selectCartTotalPrice } from '../../selector/cart'
import { localStorageApi } from '../../../helper/localStorageApi'
import { derivePaymentView } from './derivePaymentView'

export const getClientMonitorConfigThunk = () => dispatch => {
	return getClientMonitorConfig()
		.then((res) => {
			dispatch(setClientMonitorConfig(res.data))
		}).catch((error) => {
			retrieveErrorFromApi(error)
		})
}

export const getClientMonitorPublicConfigThunk = () => dispatch => {
	return getClientMonitorPublicConfig()
		.then((res) => {
			dispatch(setClientMonitorConfig(res.data))
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const updateClientMonitorConfigThunk = (config) => dispatch => {
	dispatch(setClientMonitorConfig(config))
	return updateClientMonitorConfig(config).then((res) => {
		dispatch(setClientMonitorConfig(res.data))
	}).catch((error) => {
		dispatch(getClientMonitorConfigThunk())
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	})
}

export const startClientMonitorThunk = () => async (dispatch, getState) => {
	try {
		const res = await getClientMonitorConfig()
		if (res.data.enabled) {
			if (withJsClientMonitor()) {
				openClientMonitorWindow()
				if (isNativeAppMode()) {
					sendMessageToClientMonitor('cashdesk.CLIENT_MONITOR_CONFIG_CHANGED', res.data)
				} else {
					window.addEventListener('message', (event) => {
						if (event.data?.type === 'client-monitor.CLIENT_MONITOR_LOADED') {
							sendMessageToClientMonitor('cashdesk.CLIENT_MONITOR_CONFIG_CHANGED', res.data)
						}
					})
				}
			} else {
				dispatch(updateClientMonitorConfigThunk({
					...res.data, enabled: true
				}))
			}
		}
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	}
}

export const stopClientMonitorThunk = () => async dispatch => {
	try {
		const res = await getClientMonitorConfig()
		if (!res.data.enabled) {
			closeClientMonitorWindow()
		}
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	}
}

export const resyncClientMonitorThunk = () => async (dispatch, getState) => {
	if (getState().clientMonitorConfig?.forbidden) {
		return
	}

	if (!selectIsAuthorized(getState())) {
		closeClientMonitorWindow()
		return
	}

	let config
	try {
		const res = await getClientMonitorConfig()
		config = res.data
		dispatch(setClientMonitorConfig(config))
	} catch (error) {
		if (error.response?.status === 403) {
			dispatch(setClientMonitorConfigForbidden(true))
		}
		return
	}

	if (!config?.enabled) {
		closeClientMonitorWindow()
		return
	}

	openClientMonitorWindow()
	sendMessageToClientMonitor('cashdesk.CLIENT_MONITOR_CONFIG_CHANGED', config)

	const state = getState()

	const desktopDeviceId = localStorageApi.getItem('desktopDeviceId')
	const cashDeskCart = selectClientMonitorItems('CASH_DESK', desktopDeviceId)(state)
	const deliveryCart = selectClientMonitorItems('DELIVERY', desktopDeviceId)(state)
	const hasCashDeskItems = cashDeskCart.purchaseItems.length || cashDeskCart.payments.length
	const cartState = hasCashDeskItems ? cashDeskCart : deliveryCart
	sendMessageToClientMonitor('cashdesk.CART_STATE_CHANGED_EVENT', { cartState })

	dispatch(storeClientMonitorQrCodePaymentSessionThunk())

	const paymentAmount = selectCartTotalPrice(hasCashDeskItems ? 'CASH_DESK' : 'DELIVERY')(state)
	sendMessageToClientMonitor('cashdesk.PAYMENT_STATUS_CHANGED', derivePaymentView(state.cartPayment || {}, paymentAmount))
}

export const toggleClientMonitorThunk = (state) => async dispatch => {
	try {
		await toggleClientMonitor(state)
		dispatch(getClientMonitorConfigThunk())
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	}
}

